var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-auth-profile"},[_c('h1',{staticClass:"text-align-center"},[_vm._v("个人中心页面")])])
}]

export { render, staticRenderFns }